export default __webpack_public_path__ + "static/media/users.b74479ce.svg";